import { render, staticRenderFns } from "./TeamShow.vue?vue&type=template&id=7c7804f5&scoped=true&"
import script from "./TeamShow.vue?vue&type=script&setup=true&lang=js&"
export * from "./TeamShow.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TeamShow.vue?vue&type=style&index=0&id=7c7804f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7804f5",
  null
  
)

export default component.exports